module.exports = __webpack_public_path__ + "img/finance-commission.7cf3b99a.svg";